import { useMemo } from "react";
import { useSelector } from "react-redux";
import ArrowSorting from "../../../../components/common/ArrowSorting";
import { USER_TABLE_HEADERS } from "../../utils/userTable.config";
import UsePermissionsClaim from "../../../../CustomHooks/UsePermissionsClaim";

export default function UserTableHead({
  isSelectionMode,
  allSelected,
  handleSelectAllUsers,
  isDataAvailable,
}) {
  const data = useSelector((state) => state.data.data);
  const { checkPermission } = UsePermissionsClaim();

  const addLoanPerm = checkPermission("add_loan");
  const addLoanRepaymentPerm = checkPermission("add_loan_expense");
  const addDeductionPerm = checkPermission("add_deduction_expense");
  const addUpdateUserPerm = checkPermission("update_user");
  const overTimePerm = checkPermission("payroll_addition");
  const salaryDeductPerm = checkPermission("payroll_deduction");
  const updateAdminsPerm = checkPermission("sup_admin_check");
  const disableUserPerm = checkPermission("disable_user");

  const filterHeadList = useMemo(() => {
    if (
      !addLoanPerm &&
      !addLoanRepaymentPerm &&
      !addDeductionPerm &&
      !addUpdateUserPerm &&
      !overTimePerm &&
      !salaryDeductPerm &&
      !updateAdminsPerm &&
      !disableUserPerm
    ) {
      return USER_TABLE_HEADERS.filter((i) => i.title !== "Action");
    }
    return USER_TABLE_HEADERS;
  }, [
    addDeductionPerm,
    addLoanPerm,
    addLoanRepaymentPerm,
    addUpdateUserPerm,
    disableUserPerm,
    overTimePerm,
    salaryDeductPerm,
    updateAdminsPerm,
  ]);

  return (
    <thead>
      <tr className="table-head-row">
        {isSelectionMode && isDataAvailable && (
          <th className="table-head-th p-3">
            <input
              type="checkbox"
              checked={allSelected}
              onChange={handleSelectAllUsers}
              className="w-4 h-4 accent-input"
            />
          </th>
        )}
        {filterHeadList.map((item, ind) => {
          return (
            <th className="table-head-th" key={ind}>
              <span className="flex justify-center">
                {item.title}
                {item.sortArrow && data.length > 1 && (
                  <ArrowSorting sortBy={item.sortBy} address={item.address} />
                )}
              </span>
            </th>
          );
        })}
      </tr>
    </thead>
  );
}
